import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "about" */ '../views/home.vue')
  },
  {
    path: '/verify',
    name: 'Verify',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/verify.vue')
  },
  // {
  //   path: '/slider',
  //   name: 'Slider',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/old_views/Slider.vue')
  // },
  {
    path: '/offer',
    name: 'Slider',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/process.vue')
  },

  {
    path: '/docusign_completed',
    name: 'DocuSignCompleted',
    component: () => import(/* webpackChunkName: "about" */ '../views/completed_docusign.vue')
  },
  // {
  //   path: '/signed',
  //   name: 'Signed',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/old_views/signed.vue')
  // },
  {
    path: '/all_artists',
    name: 'AllArtists',
    component: () => import(/* webpackChunkName: "about" */ '../views/old_views/admin_artists.vue')
  },
  {
    path: '/wallet',
    name: 'Wallet',
    component: () => import(/* webpackChunkName: "about" */ '../views/wallet/wallet.vue')
  },
  {
    path: '/approval',
    name: 'approval',
    component: () => import(/* webpackChunkName: "about" */ '../views/wallet/approval.vue')
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import(/* webpackChunkName: "about" */ '../views/wallet/Signup.vue')
  },
  // { path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import( '../views/old_views/Slider.vue') },
  {
    path: '/test',
    name: 'signup',
    component: () => import(/* webpackChunkName: "about" */ '../views/test.vue')
  },
  // { path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import( '../views/old_views/Slider.vue') },

]

const router = createRouter({
  history: createWebHistory((process.env.VUE_APP_ENV === 'TEST') ? 'testing/' : ''),
  routes
})

export default router
